import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {SpecialEntityModel} from "../special-entity.model";
import {Plugin} from "../../../config";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {
    SpecialScheduleEditPageComponent
} from "../../special-schedule/special-schedule-edit-page/special-schedule-edit-page.component";
import {PricingScheduleSummaryData} from "../../pricing-schedule/pricing-schedule.data";
import {
    FUIAlertAction,
    FUIAlertActions,
    FUIAlertService,
    FUIResponsiveService,
    FUISpinnersService
} from "@fedeltapointofsale/ui";
import {
    DiscontinueSearchActionComponent
} from "../../../framework/common-controls/actions/discontinue-search-action.component";
import {
    SpecialScheduleDiscontinueAction,
    SpecialScheduleDiscontinueService
} from "../special-schedule-discontinue.service";
import {ProductSpecialData, SpecialProductLoyaltyData, SpecialScheduleSummaryData} from "../special.data";
import {FormGroup} from "@angular/forms";
import {Markup_Type} from "../../markup/markup.data";
import {
    ProductLineSearchPageComponent
} from "../../../catalogue/product-line/product-line-search-page/product-line-search-page.component";
import {
    ProductLineEditPageComponent
} from "../../../catalogue/product-line/product-line-edit-page/product-line-edit-page.component";
import {
    CompositeProductSearchPageComponent
} from "../../../catalogue/composite-product/composite-product-search-page/composite-product-search-page.component";
import {
    CompositeProductEditPageComponent
} from "../../../catalogue/composite-product/composite-product-edit-page/composite-product-edit-page.component";
import {PointsData} from "../../../customers/points/points.data";
import {PriceLevelSearchModel} from "../../price-level/price-level-search.model";

@Component({
    selector: "wbo-special-edit-page",
    templateUrl: "./special-edit-page.component.html",
    providers: [
        provideEntityModel(SpecialEntityModel),
        SpecialScheduleDiscontinueService
    ]
})
export class SpecialEditPageComponent extends AbstractEditPage {
    Plugin = Plugin;
    EditMode = EditMode;
    SpecialScheduleEditPageComponent = SpecialScheduleEditPageComponent;
    PricingScheduleSummaryData = PricingScheduleSummaryData;
    ProductLineSearchPageComponent = ProductLineSearchPageComponent;
    ProductLineEditPageComponent = ProductLineEditPageComponent;
    CompositeProductSearchPageComponent = CompositeProductSearchPageComponent;
    CompositeProductEditPageComponent = CompositeProductEditPageComponent;
    PriceLevelSearchModel = PriceLevelSearchModel;

    constructor(public model: SpecialEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService,
                private specialScheduleDiscontinueService: SpecialScheduleDiscontinueService,
                private alertService: FUIAlertService,
                private spinnersService: FUISpinnersService) {
        super(changeDetectorRef, responsiveService);
    }

    async discontinueSchedule(specialScheduleSummary: SpecialScheduleSummaryData): Promise<void> {
        const action: FUIAlertAction = await this.alertService.showConfirmationOkCancel(DiscontinueSearchActionComponent.title, DiscontinueSearchActionComponent.message)
            .toPromise();
        if (action === FUIAlertActions.OK_ACTION) {
            this.spinnersService.open(true);
            try {
                await this.specialScheduleDiscontinueService.performAction(new SpecialScheduleDiscontinueAction(specialScheduleSummary.specialScheduleId));
                specialScheduleSummary.discontinued = true;
            } finally {
                this.spinnersService.close();
            }
        }
    }

    scheduleRowRemovable(rowIndex: number, specialScheduleSummary: SpecialScheduleSummaryData): boolean {
        return !specialScheduleSummary.discontinued;
    }

    markupTypeChanged({value, dataItem, formGroup}: { value: any, dataItem: any, formGroup: FormGroup }): void {
        // Live update of data item to allow notation on amount column to change
        dataItem.markup.type = value;
    }

    afterSellablePricingAdded(entity: ProductSpecialData): void {
        entity.markup.value = entity.product.price;
        entity.markup.type = Markup_Type.OVERRIDE;
    }

    afterSellableRewardsAdded(entity: SpecialProductLoyaltyData): void {
        entity.accrual.type = PointsData.TYPE_PER_UNIT_AT_ANY_PRICE;
    }
}
